// extracted by mini-css-extract-plugin
export default {"container":"Dropdown_container__5URUC","select":"Dropdown_select__-ylkl","arrows":"Dropdown_arrows__nqXWP"};